import Swiper, { Pagination, Manipulation } from "swiper";
import { updateHoverSliders, addToGlobalThisRet } from "@plugins";

window.addEventListener("load", () => {
    if (window.mobileMedia) {
        initInstructionsSlider();
        updateHoverSliders();
    }
});

function initInstructionsSlider() {
    const instructionsSlider = document.querySelector(".js-instructions");

    if (instructionsSlider) {
        const sliderContainer = instructionsSlider.querySelector(".js-instructions-slider");
        const sliderPagination = instructionsSlider.querySelector(".js-instructions-pagination");

        const swiper = new Swiper(sliderContainer, {
            modules: [Pagination, Manipulation],
            speed: 400,
            spaceBetween: 16,
            pagination: {
                el: sliderPagination,
                type: "progressbar",
            },
            breakpoints: {
                370: {
                    slidesPerView: 1.2,
                },
                406: {
                    slidesPerView: 1.3,
                },
                567: {
                    slidesPerView: 2,
                },
                768: {
                    slidesPerView: 3,
                },
            },
        });

        swiper.once("reachEnd", () => {
            swiper.appendSlide(`
                <div class="swiper-slide slider-link-load-more instructions__load-more js-load-more-instructions">
                    <span class="simple-link instructions__load-more-btn"> 
                        Все инструкции <br>
                        для моек
                    </span>
                </div>
            `);
            document.querySelector(".js-load-more-instructions").addEventListener("click", () => {
                document.querySelector(".js-instructions-link").click();
            });
        });
    }
}

addToGlobalThisRet(initInstructionsSlider, "initInstructionsSlider");
